<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 20 24"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="black" height="21" width="20" y="3"/>
    <rect fill="#C286BE" height="3" width="20"/>
    <path d="M8.82161 8H11.1788L15.7045 19H13.3945L12.2945 15.9986H7.61161L6.4959 19H4.2959L8.82161 8ZM10.393 10.8286C10.2149 10.3571 10.0735 9.93286 9.96876 9.55571C9.91637 9.70238 9.85352 9.88571 9.78018 10.1057C9.70685 10.3152 9.6178 10.5562 9.51304 10.8286L8.2559 14.2543H11.6502L10.393 10.8286Z" fill="white"/>
  </svg>
</template>

<script>
export default {
  name: 'EyeAppealA',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
  },
};

</script>
